<app-base-modal
  [title]="'Повторы'"
  [modalMaxHeight]="'90vh'"
>
  @if (isLoading) {
    <app-loader/>
  } @else {
    @for (table of repeatsTable; track $index) {
      <section>
        <h3>{{ table.title }}</h3>
        <app-repeats-table
          [resourceParamsKey]="table.key"
          [tableRecords]="getTableData(table.key)"
        />
      </section>
    }
  }
</app-base-modal>
